import { FC } from "react";
import classNames from "classnames";
import { DropDownIco } from "../../../assets/customIcons";
import Spinner from "../../Spinner";

import styles from "./SelectSkeleton.module.scss";

export const SelectSkeleton: FC = ({}) => {
  return (
    <div className={classNames(styles.SelectSkeleton)}>
      <DropDownIco />
      <Spinner />
    </div>
  );
};
